module.exports = __webpack_public_path__ + "f0abe15e8c631530a71827687b39bb80.png";